import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Gelule = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.21 82.2">
  <G fill={color}>
    <Path d="M75.67,6.54c-8.71-8.72-22.9-8.71-31.61,0L6.54,44.06c-8.71,8.72-8.71,22.89,0,31.61,4.36,4.36,10.08,6.54,15.81,6.54s11.45-2.18,15.8-6.54l37.52-37.52h0c8.72-8.72,8.72-22.9,0-31.61ZM16.79,69.5c-.56.56-1.3.85-2.04.85s-1.48-.28-2.04-.85c-2.57-2.57-3.99-6-3.99-9.64s1.42-7.06,3.99-9.64c1.13-1.13,2.96-1.13,4.09,0,1.13,1.13,1.13,2.96,0,4.09-1.48,1.48-2.3,3.45-2.3,5.55s.82,4.07,2.3,5.55c1.13,1.13,1.13,2.96,0,4.09ZM71.58,34.06l-15.86,15.86c-.07-.03-.14-.06-.21-.09-.08-.02-8.12-2.42-14.42-8.72-5.21-5.21-8.18-12.08-9.07-14.36l16.13-16.13c3.23-3.23,7.48-4.85,11.72-4.85s8.49,1.62,11.72,4.85c6.46,6.46,6.46,16.98,0,23.44Z"/>
  </G>
</Svg>
);
};

export default Gelule;
